import createModel from './lib/create_model';

const AgentRead = createModel({
  modelName: 'AgentRead',

  properties: {
    conversationId: String,
    agentId: String,
    readTo: String,
  },

  // Whether this read is for the same conversation as `other` and at least as far along.
  covers(other) {
    return !!other && this.conversationId === other.conversationId && isReadToAtLeast(this.readTo, other.readTo);
  },

  // A customer's store only holds the read for its latest conversation, so a read for an older conversation must not
  // replace it.
  shouldReplace(existingRead, latestConversationId) {
    if (!existingRead) {
      return true;
    }
    if (existingRead.conversationId === this.conversationId) {
      return !existingRead.covers(this);
    }
    return this.conversationId === latestConversationId || existingRead.conversationId !== latestConversationId;
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    isReadToAtLeast,
  },
});

function isReadToAtLeast(readTo, otherReadTo) {
  return !!readTo && (!otherReadTo || new Date(readTo) >= new Date(otherReadTo));
}

export default AgentRead;
